


'use strict';

const AjaxInjector = require('./ajaxInjector');

function setupZipCheck ( zipCode, houseNumber, street, city ) {
    if ( zipCode && houseNumber && (street || city) ) {
        const zipCheck = function () {
            if ( zipCode.value && houseNumber.value ) {
                AjaxInjector.request(
                    '/ajax/customer/Postcode',
                    'POST',
                    {
                        zipCode: zipCode.value,
                        houseNumber: houseNumber.value
                    })
                    .then(response => {
                        if ( response.street && response.city) {
                            street.value = response.street;
                            city.value = response.city;
                        }
                    });
            }
        };


        [zipCode, houseNumber]
            .forEach(input => input.addEventListener('change', () => {
                zipCheck();
            }));

        zipCheck();
    }
}

export default function zipCheck (formSelector) {
    const forms = document.querySelectorAll(formSelector);

    forms.forEach(form => {
        const zipCode = form.querySelector('input.zipCode');
        const houseNumber = form.querySelector('input.houseNumber');
        const street = form.querySelector('input.street');
        const city = form.querySelector('input.city');

        setupZipCheck(
            form.querySelector('input.zipCode'),
            form.querySelector('input.houseNumber'),
            form.querySelector('input.street'),
            form.querySelector('input.city')
        );

        setupZipCheck(
            form.querySelector('input.zipCode.delivery'),
            form.querySelector('input.houseNumber.delivery'),
            form.querySelector('input.street.delivery'),
            form.querySelector('input.city.delivery')
        );
    });
}
